<template>
    <v-dialog :fullscreen="isMobile" v-model="dialog" transition="slide-x-reverse-transition" max-width="500">
        <v-card tile flat>
            <v-app-bar color="white" flat>
                <v-btn icon @click="hide" v-if="isMobile">
                    <v-icon color="secondary">mdi-arrow-left</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <div class="app-title">
                    {{ $t('entrance.remember_password_title') }}
                </div>
                <v-spacer></v-spacer>
                <v-btn icon @click="hide" v-if="!isMobile">
                    <v-icon color="secondary">mdi-close</v-icon>
                </v-btn>
            </v-app-bar>

            <v-card-text>
                <div v-if="passwordRecoverySuccess" class="py-4">
                    <v-alert color="secondary" dark border="left" icon="mdi-check-circle-outline" prominent>
                        {{ $t('entrance.email_request_send') }}
                    </v-alert>
                </div>
                <v-form v-else v-model="valid">
                    <v-row>
                        <v-col cols="12">
                            <kimsa-text-field
                                :label="$t('entrance.email')"
                                :placeholder="$t('entrance.email_placeholder')"
                                :rules="emailRules"
                                @change="email = $event"
                                :inputMode="'email'"
                                :readonly="loadingPasswordRecovery"
                                :loading="loadingPasswordRecovery"
                            />
                        </v-col>
                        <v-col cols="12">

                            <v-btn
                                class="black--text b1"
                                color="primary"
                                depressed
                                block
                                :loading="loadingPasswordRecovery"
                                @click="passwordRecovery"
                            >
                                {{ $t('common.continue') }}
                            </v-btn>

                            <v-btn
                                class="mt-3 text-lowercase"
                                depressed
                                block
                                text
                                @click="hide"
                            >
                                {{ $t('common.cancel') }}
                            </v-btn>

                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import {mapMutations, mapState} from 'vuex'

import firebase from 'firebase/app'
import 'firebase/auth'

export default {
    components: {KimsaTextField},
    data(vm = this) {
        return {
            dialog: false,
            valid: false,
            loadingPasswordRecovery: false,
            passwordRecoverySuccess: false,
            email: '',
            emailRules: [
                v => !!v || vm.$t('rules.required'),
                v => new RegExp(/.+@.+\..+/).test(v) || vm.$t('rules.invalid_email')
            ],
        }
    },
    methods: {
        ...mapMutations(['setDialogActive']),
        show() {
            const vm = this
            vm.dialog = true
            vm.setDialogActive(true)
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.setDialogActive(false)
            vm.reset()
        },
        reset() {
            const vm = this
            vm.loadingPasswordRecovery = false
            vm.passwordRecoverySuccess = false
            vm.email = ''
        },
        async passwordRecovery() {
            const vm = this
            if (!vm.valid) return vm.toast(vm.$t('rules.invalid_email'), 'error')
            if (vm.loadingPasswordRecovery === true) return
            vm.loadingPasswordRecovery = true
            firebase.auth().sendPasswordResetEmail(vm.email).then(() => {
                vm.loadingPasswordRecovery = false
                vm.passwordRecoverySuccess = true
            }).catch(error => {
                console.log('error', error)
                vm.loadingPasswordRecovery = false
                vm.toast(vm.$t('entrance.error_sending_email'), 'error')
            });
        }
    },
    computed: {
        ...mapState(['dialogActive'])
    },
    watch: {
        dialogActive(val) {
            if (!val) this.hide()
        },
        passwordRecoverySuccess(val) {
            if (val) {
                setTimeout(() => {
                    this.hide()
                }, 3000)
            }
        }
    }
}
</script>

<style scoped>

</style>
